(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-sidebar-category"]) return;
  try {
    
$(document).ready(function(){
  $(".dt-menu-expand").click(function(event){
    event.preventDefault();
    if( $(this).hasClass("dt-mean-clicked") ){
      $(this).text("+");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
      } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
      }
    } else {
      $(this).text("-");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
      } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
      }
    }

    $(this).toggleClass("dt-mean-clicked");
    return false;
  });

});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sidebar-featured-postBk"]) return;
  try {
    
$(document).ready(function(){
     var homeSidefp = $(".home-sidebar-featured-post__inner");
      homeSidefp.owlCarousel({
      items:1,
      dots: false,  
      autoplay:true,
      smartSpeed : 1000,
      navSpeed : 1000,
         responsive:{
      0:{
      items: 1
      },
      600:{
      items:1
      },
      700:{
      items:1
      },
      1000:{
      items: 1
      }
      }
      });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-promo-img-2"]) return;
  try {
    
 $(document).ready(function(){
     var promoimage_2 = $("#promo-carousel_2");
      promoimage_2.owlCarousel({
         items:1,
         loop:false,              
         dots: false,  
          autoplay:true,
         responsive:{
           0:{
             items: 1
           },
           600:{
             items:1
           },
           700:{
             items: 1
           },           
           1000:{
             items: 1
           }
         }
  			});
        });

  } catch(e) { console.error(e); }
})();
})();
